<div class="ft-tile"
    [class.ft-changed] ="(this.onFaultStateChanged$ | async) == faultStates.InProgress"
    [class.ft-error] ="(this.onFaultStateChanged$ | async) == faultStates.Error">
</div>
